export default __webpack_public_path__ + "static/media/logo-horizontal.016e5ef9.png";